export const AutoUnsubscribe = constructor => {
  const original = constructor.prototype.ngOnDestroy;
  constructor.prototype.ngOnDestroy = function () {
    for (const prop in this) {
      const property = this[prop];
      if (Array.isArray(property)) {
        property.forEach(sub => {
          if (sub && typeof sub.unsubscribe === 'function') {
            sub.unsubscribe();
          }
        });
      } else if (property && typeof property.unsubscribe === 'function') {
        property.unsubscribe();
      }
    }
    if (original && typeof original === 'function') {
      original.apply(this, arguments);
    }
  };
};
